import { CvDateFormatter, DATEFORMAT } from "@cv-invision/cv.component-library.ux";

export class COLUMNS_MIMUTUAL {
	private _columns: Array<any>;

	constructor(dateService:CvDateFormatter) {
		this._columns = [
			{
				headerName: 'ID',
				field: 'id',
			},
			{
				headerName: 'Provider',
				field: 'provider',
			},
			{
				headerName: 'Provider ID',
				field: 'providerId',
			},
			{
				headerName: 'Loan Number',
				field: 'loanNumber',
			},
			{
				headerName: 'Created On',
				field: 'created',
				valueFormatter: params => dateService.format(DATEFORMAT.YYYY_MM_DD, params.data.created),
			},
			{
				headerName: 'Logs',
				width: 80,
				cellRenderer: 'CustomActionPartialOrdersCellComponent'
			}
		]
	}

	get columns(): Array<any> {
		return this._columns;
	}
};

export class FILTER_MIMUTUAL {
	provider: string;
	providerId: string;
	loanNumber: string;
	limit: number;

	constructor(provider = '', providerId = '', loanNumber = '', limit = 20) {
        this.provider = provider;
        this.providerId = providerId;
        this.loanNumber = loanNumber;
        this.limit = limit;
    }
};

export const DATA_MIMUTUAL = (data: any) => [
	{ name: 'Appraisal ID', value: data.appraisalId },
	{ name: 'Appraisal File Number', value: data.appraisalFileNumber },
	{ name: 'Status ID', value: data.statusId },
	{ name: 'Status Name', value: data.statusName },
	{ name: 'Assigned To', value: data.assignedTo },
	{ name: 'Client ID', value: data.clientId },
	{ name: 'Loan Number', value: data.loanNumber },
	{ name: 'Scope Branch Name', value: data.scopeBranchName },
	{ name: 'Client Name', value: data.clientName },
	{ name: 'Created On', value: data.createdOn }
];
